import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from '../core/services/data.service';
import { ClosingDisclosureDocRequestFormModel } from '../cd-request/models/closing-disclosure-doc-request.model';

@Injectable({
  providedIn: 'root'
})
export class CdRequestService {

  constructor(private readonly _dataService: DataService) {}

  getCdRequest(loanId: number): Observable<ClosingDisclosureDocRequestFormModel> {
    const url = `api/loan/${loanId}/cd-request`;
    return this._dataService.get(url);
  }

  getCorrIcdRequest(loanId: number, flowType?: string): Observable<ClosingDisclosureDocRequestFormModel> {
    let url = `api/loan/${loanId}/corr-icd-request`;
    if (flowType) {
      url += `?flowType=${flowType}`;
    }
    return this._dataService.get(url);
  }

  saveCdRequestDraft(loanId: number, data: any): Observable<any> {
    const url = `api/loan/${loanId}/cd-request`;
    return this._dataService.put(url, data);
  }

  submitCdRequest(loanId: number, data: any): Observable<any> {
    const url = `api/loan/${loanId}/cd-request/submit`;
    return this._dataService.post(url, data);
  }

  saveCorrIcdRequestDraft(loanId: number, data: any): Observable<any> {
    const url = `api/loan/${loanId}/corr-icd-request`;
    return this._dataService.put(url, data);
  }

  submitCorrIcdRequest(loanId: number, data: any): Observable<any> {
    const url = `api/loan/${loanId}/corr-icd-request/submit`;
    return this._dataService.post(url, data);
  }
}
